import React from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Workflow } from "../../Models/Workflow";
import styles from "../../Styles/WorkflowSelector.module.scss";

type Props = {
  workflowOptions: Workflow[];
  selectedWorkflow?: Workflow;
  onSelectedWorkflowChange: (newWorkflow: Workflow) => void;
};

type State = {
  isDropdownOpen: boolean;
};

export default class WorkflowSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isDropdownOpen: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState: State) => ({
      isDropdownOpen: !prevState.isDropdownOpen
    }));
  }

  render() {
    return (
      <Dropdown
        className={styles.workflowSelector}
        isOpen={this.state.isDropdownOpen}
        toggle={this.toggle}
      >
        <DropdownToggle className={styles.dropdownToggle} caret>
          {!!this.props.selectedWorkflow && <>{this.props.selectedWorkflow.name}</>}
          {!this.props.selectedWorkflow && <>Workflow Not Selected</>}
        </DropdownToggle>
        <DropdownMenu>
          {this.props.workflowOptions.map((el: Workflow) => {
            const isSelected = this.props.selectedWorkflow
              ? el.code === this.props.selectedWorkflow.code
              : false;

            return (
              <DropdownItem
                key={el.code}
                active={isSelected}
                onClick={() => {
                  this.props.onSelectedWorkflowChange(el);
                }}
              >
                {el.name}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    );
  }
}
